// 常量路由

import systemManageRouter from '@/router/modules/systemManage'

export const constantRoutes = [{
    path: '/',
    redirect: '/login',
    meta: {
        hidden: true
    }
},
    {
        path: '/login',
        meta: {
            hidden: true
        },
        component: () =>
            import ('@/views/login/index')
    },
    // {
    //     path: '/home',
    //     name: 'Home',
    //     meta: {
    //         icon: 'el-icon-s-home',
    //         name: '首页'
    //     },
    //     component: () =>
    //         import ('../views/home/index.vue')
    // }
]

// 任意路由
export const anyRoutes = [
    //
]

// 动态路由
export const asyncRoutes = () => [
    {
        path: '/agent/list',
        name: 'AgentList',
        component: () => import('@/views/agent/agent-list/list.vue'),
        meta: {name: '代理商管理', icon: 'el-icon-user-solid'}
    },
    // 商户管理
    // {
    //   path: '/merchant/list',
    //   name: 'MerchantList',
    //   component: () => import('@/views/merchant/merchant-list/list.vue'),
    //   meta: { name: '商户申请管理', icon: 'el-icon-s-shop' }
    // },
    // 收货地址管理
    // {
    //   path: '/address/list',
    //   name: 'AddressList',
    //   component: () => import('@/views/address/list.vue'),
    //   meta: { name: '收货地址管理', icon: 'el-icon-s-shop' }
    // },
    // 公海
    // {
    //     path: '/highSeas/list',
    //     name: 'HighSeas',
    //     component: () =>
    //         import ('@/views/highSeas/list.vue'),
    //     meta: {name: '公海', icon: 'el-icon-s-shop'}
    // },
    // 客户管理
    // {
    //     path: '/customerManage',
    //     name: 'CustomerManage',
    //     redirect: '/customerManage/overview',
    //     component: () =>
    //         import ('@/views/customer/index.vue'),
    //     meta: {name: '客户管理', icon: 'el-icon-s-custom'},
    //     children: [{
    //         path: '/customerManage/overview',
    //         name: 'CustomerOverview',
    //         component: () =>
    //             import ('@/views/customerManage/customerOverview/overview.vue'),
    //         meta: {name: '客户总览'}
    //     },
    //         {
    //             path: '/customerManage/intended/list',
    //             name: 'IntendedCustomers',
    //             component: () =>
    //                 import ('@/views/customerManage/intendedCustomers/list.vue'),
    //             meta: {name: '意向客户'}
    //         },
    //         {
    //             path: '/customerManage/transit/list',
    //             name: 'TransitCustomers',
    //             component: () =>
    //                 import ('@/views/customerManage/transitCustomers/list.vue'),
    //             meta: {name: '在途客户'}
    //         },
    //         {
    //             path: '/customerManage/prospective/list',
    //             name: 'ProspectiveCustomers',
    //             component: () =>
    //                 import ('@/views/customerManage/prospectiveCustomers/list.vue'),
    //             meta: {name: '准客户'}
    //         },
    //         {
    //             path: '/customerManage/reject/list',
    //             name: 'RejectCustomers',
    //             component: () =>
    //                 import ('@/views/customerManage/rejectCustomers/list.vue'),
    //             meta: {name: '拒收客户'}
    //         },
    //         {
    //             path: '/customerManage/activate/list',
    //             name: 'ActivateCustomers',
    //             component: () =>
    //                 import ('@/views/customerManage/activateCustomers/list.vue'),
    //             meta: {name: '激活客户'}
    //         },
    //         {
    //             path: '/customerManage/complaint/list',
    //             name: 'ComplaintCustomers',
    //             component: () =>
    //                 import ('@/views/customerManage/complaintCustomers/list.vue'),
    //             meta: {name: '投诉客户'}
    //         },
    //         {
    //             path: '/customerManage/remark/list/:customer_id',
    //             name: 'customerRemarkList',
    //             component: () =>
    //                 import ('@/views/customerManage/customerRemark/list.vue'),
    //             meta: {
    //                 hidden: true,
    //                 name: '备注记录'
    //             }
    //         }
    //     ]
    // },
    // 数据分析
    // {
    //     path: '/dataAnalysis',
    //     name: 'DataAnalysis',
    //     redirect: '/dataAnalysis/overview',
    //     component: () =>
    //         import ('@/views/dataAnalysis/index.vue'),
    //     meta: {name: '数据分析', icon: 'el-icon-s-data'},
    //     children: [
    //         // {
    //         //     path: '/dataAnalysis/overview',
    //         //     name: 'DataOverview',
    //         //     component: () =>
    //         //         import ('@/views/dataAnalysis/overview.vue'),
    //         //     meta: { name: '数据总览' }
    //         // },
    //         {
    //             path: '/dataAnalysis/list',
    //             name: 'DataList',
    //             component: () =>
    //                 import ('@/views/dataAnalysis/list.vue'),
    //             meta: {name: '业务用户分析'}
    //         },
    //         {
    //             path: '/dataAnalysis/posTerminalDataStat',
    //             name: 'PosTerminalDataStat',
    //             component: () =>
    //                 import ('@/views/dataAnalysis/posTerminalDataStat.vue'),
    //             meta: {name: '用户上月等级'}
    //         }
    //     ]
    // },
    // 终端管理
    // {
    //     path: '/terminal/list',
    //     name: 'TerminalManage',
    //     component: () =>
    //         import ('@/views/terminal/list.vue'),
    //     meta: {name: '终端管理', icon: 'el-icon-s-shop'}
    // },
    // 售后管理
    // {
    //     path: '/afterSaleManage',
    //     name: 'AfterSaleManage',
    //     component: () =>
    //         import ('@/views/afterSaleManage/list.vue'),
    //     meta: {name: '售后管理', icon: 'el-icon-goods'}
    // },
    // 下载中心
    // {
    //     path: '/downloadManage/list',
    //     name: 'DownloadManage',
    //     component: () =>
    //         import ('@/views/downloadManage/list.vue'),
    //     meta: {name: '下载中心', icon: 'el-icon-download'}
    // },
    // 撞库数据
    // {
    //     path: '/collisionManage/list',
    //     name: 'CollisionManage',
    //     component: () =>
    //         import ('@/views/collisionManage/list.vue'),
    //     meta: {name: '撞库数据', icon: 'el-icon-picture-outline-round'}
    // },
    // 品牌管理
    // {
    //     path: '/brand/list',
    //     name: 'BrandList',
    //     component: () =>
    //         import ('@/views/brand/brand-list/list.vue'),
    //     meta: {name: '品牌管理', icon: 'el-icon-s-cooperation'}
    // },
    // {
    //     path: '/brand/model/list/:brand_id',
    //     name: 'BrandModelList',
    //     component: () =>
    //         import ('@/views/brand/model-list/list.vue'),
    //     meta: {
    //         hidden: true,
    //         name: '规格管理'
    //     }
    // },

    {
        path: '/posNotify_data',
        name: 'posNotify_data',
        redirect: '/posNotify/posData/active/list',
        component: () => import ('@/views/PosNotify/PosData/index.vue'),
        meta: {name: 'POS清洗数据', icon: 'el-icon-s-check'},
        children: [
            {
                path: '/posNotify_data/posData/active/list',
                name: 'PosDataActive',
                component: () =>
                    import ('@/views/PosNotify/PosData/active/list.vue'),
                meta: {
                    name: '商户绑定',
                }
            },
            {
                path: '/posNotify_data/posData/dealOrder/list',
                name: 'PosDataActiveDealOrder',
                component: () =>
                    import ('@/views/PosNotify/PosData/dealOrder/list.vue'),
                meta: {
                    name: '交易数据',
                }
            },
            {
                path: '/posNotify_data/posData/simYearFee/list',
                name: 'PosDataActiveSimYearFee',
                component: () =>
                    import ('@/views/PosNotify/PosData/simYearFee/list.vue'),
                meta: {
                    name: 'SIM卡年费',
                }
            },
        ]
    },

    {
        path: '/posNotify_42054639',
        name: 'posNotify_42054639',
        redirect: '/posNotify/42054639/list',
        component: () => import ('@/views/PosNotify/AgentSftOfficial/index.vue'),
        meta: {name: '盛付通', icon: 'el-icon-s-check'},
        children: [
            {
                path: '/posNotify/active/list',
                name: 'posBind',
                component: () =>
                    import ('@/views/PosNotify/AgentSftOfficial/posBind/list.vue'),
                meta: {
                    name: 'POS机具激活明细',
                    agent_id: '',
                }
            },
            {
                path: '/posNotify/posServiceFee/list',
                name: 'posServiceFeeList',
                component: () =>
                    import ('@/views/PosNotify/AgentSftOfficial/posServiceFee/list.vue'),
                meta: {
                    name: '服务费收取通知',
                }
            },
            {
                path: '/posNotify_42054639/posSettlement/list',
                name: 'posSettlementList',
                component: () =>
                    import ('@/views/PosNotify/AgentSftOfficial/posSettlement/list.vue'),
                meta: {
                    name: '交易数据',
                }
            },
            {
                path: '/posNotify/posWithdraw/list',
                name: 'posWithdrawList',
                component: () =>
                    import ('@/views/PosNotify/AgentSftOfficial/posWithdraw/list.vue'),
                meta: {
                    name: '提现通知业务',
                }
            },
            {
                path: '/posNotify/posSimYearFee/list',
                name: 'posSimYearFeeList',
                component: () =>
                    import ('@/views/PosNotify/AgentSftOfficial/posSimYearFee/list.vue'),
                meta: {
                    name: 'SIM卡年费缴纳',
                }
            },
        ]
    },

    {
        path: '/posNotify_lkl',
        name: 'posNotify_lkl',
        redirect: '/posNotify/lkl/active/list',
        component: () => import ('@/views/PosNotify/AgentLkl/index.vue'),
        meta: {name: '拉卡拉', icon: 'el-icon-s-check'},
        children: [
            {
                path: '/posNotify/lkl/active/list',
                name: 'lklActiveData',
                component: () =>
                    import ('@/views/PosNotify/AgentLkl/activeData/list.vue'),
                meta: {
                    name: '商终绑定',
                }
            },
            {
                path: '/posNotify/lkl/transactionFeeD0/list',
                name: 'lkltransactionFeeD0',
                component: () =>
                    import ('@/views/PosNotify/AgentLkl/transactionFeeD0/list.vue'),
                meta: {
                    name: '交易手续费',
                }
            },
            {
                path: '/posNotify/lkl/transactions/list',
                name: 'lkltransactions',
                component: () =>
                    import ('@/views/PosNotify/AgentLkl/transactions/list.vue'),
                meta: {
                    name: '交易流水',
                }
            },
            {
                path: '/posNotify/lkl/simYearFee/list',
                name: 'simYearFee',
                component: () =>
                    import ('@/views/PosNotify/AgentLkl/simYearFee/list.vue'),
                meta: {
                    name: 'sim卡年费',
                }
            },
        ]
    },

    // {
    //     path: '/posNotify_lkl_979188',
    //     name: 'posNotify_lkl_979188',
    //     redirect: '/posNotify/lkl_979188/active/list',
    //     component: () => import ('@/views/PosNotify/Agent_lkl/index.vue'),
    //     meta: {name: '拉卡拉-979188', icon: 'el-icon-s-check'},
    //     children: [
    //         {
    //             path: '/posNotify/lkl_979188/active/list',
    //             name: 'posBind',
    //             component: () =>
    //                 import ('@/views/PosNotify/Agent_lkl/activeData/list.vue'),
    //             meta: {
    //                 name: '商终绑定',
    //                 agent_id: 'lkl_979188',
    //                 fullname: '[拉卡拉] - 979188'
    //             }
    //         },
    //         {
    //             path: '/posNotify/lkl_979188/transactionFeeD0/list',
    //             name: 'posBind',
    //             component: () =>
    //                 import ('@/views/PosNotify/Agent_lkl/transactionFeeD0/list.vue'),
    //             meta: {
    //                 name: '交易手续费',
    //                 agent_id: 'lkl_979188',
    //                 fullname: '[拉卡拉] - 979188'
    //             }
    //         },
    //         {
    //             path: '/posNotify/lkl_979188/transactions/list',
    //             name: 'posBind',
    //             component: () =>
    //                 import ('@/views/PosNotify/Agent_lkl/transactions/list.vue'),
    //             meta: {
    //                 name: '交易流水',
    //                 agent_id: 'lkl_979188',
    //                 fullname: '[拉卡拉] - 979188'
    //             }
    //         },
    //     ]
    // },

    {
        path: '/powerManage',
        name: 'PowerManage',
        redirect: '/powerManage/user/list',
        component: () =>
            import ('@/views/powerManage/index.vue'),
        meta: {name: '权限管理', icon: 'el-icon-s-check'},
        children: [{
            path: '/powerManage/user/list',
            name: 'UserList',
            component: () =>
                import ('@/views/powerManage/user/list.vue'),
            meta: {name: '管理员管理'}
        },
            {
                path: '/powerManage/user/add',
                name: 'UserAdd',
                component: () =>
                    import ('@/views/powerManage/user/addEdit.vue'),
                meta: {
                    name: '新增账号',
                    hidden: true,
                    activeMenu: '/powerManage/user/list'
                }
            },
            {
                path: '/powerManage/user/edit/:id?',
                name: 'UserEdit',
                component: () =>
                    import ('@/views/powerManage/user/addEdit.vue'),
                meta: {
                    name: '编辑账号',
                    hidden: true,
                    activeMenu: '/powerManage/user/list'
                }
            },
            // {
            //     path: '/powerManage/role/list',
            //     name: 'RoleList',
            //     component: () =>
            //         import ('@/views/powerManage/role/list.vue'),
            //     meta: { name: '角色管理' }
            // },
            // {
            //     path: '/powerManage/role/addEdit',
            //     name: 'RoleAdd',
            //     component: () =>
            //         import ('@/views/powerManage/role/addEdit.vue'),
            //     meta: {
            //         name: '新增',
            //         hidden: true,
            //         activeMenu: '/powerManage/role/list'
            //     }
            // },
            {
                path: '/powerManage/role/addEdit/:id?',
                name: 'RoleEdit',
                component: () =>
                    import ('@/views/powerManage/role/addEdit.vue'),
                meta: {
                    name: '编辑',
                    hidden: true,
                    activeMenu: '/powerManage/role/list'
                }
            },
            {
                path: '/powerManage/menu/list',
                name: 'MenuList',
                component: () =>
                    import ('@/views/powerManage/menu/list.vue'),
                meta: {name: '代理商菜单', keepAlive: true}
            },
            {
                path: '/powerManage/menu/addEdit/:menuId?/:parentId?',
                name: 'MenuAdd',
                component: () =>
                    import ('@/views/powerManage/menu/addEdit.vue'),
                meta: {
                    name: '新增',
                    hidden: true,
                    activeMenu: '/powerManage/menu/list'
                }
            },
            {
                path: '/powerManage/menu/addEdit/:menuId?/:parentId?',
                name: 'MenuEdit',
                component: () =>
                    import ('@/views/powerManage/menu/addEdit.vue'),
                meta: {
                    name: '编辑',
                    hidden: true,
                    activeMenu: '/powerManage/menu/list'
                }
            }
        ]
    },
    systemManageRouter
    // {
    //   path: '/aliManage',
    //   name: 'AliManage',
    //   component: () => import('@/views/aliManage/index.vue'),
    //   meta: { name: '支付宝小程序', icon: 'el-icon-shopping-bag-1' },
    //   children: [
    //     {
    //       path: '/aliManage/apply/list',
    //       name: 'AliApplyList',
    //       component: () => import('@/views/aliManage/apply-list/list.vue'),
    //       meta: { name: '申请列表' }
    //     },
    //     {
    //       path: '/aliManage/product/list',
    //       name: 'ProductList',
    //       component: () => import('@/views/aliManage/product-list/list.vue'),
    //       meta: { name: '产品列表' }
    //     },

    //     {
    //       path: '/aliManage/config/list',
    //       name: 'AliConfigList',
    //       component: () => import('@/views/aliManage/config/list.vue'),
    //       meta: { name: '配置页面' }
    //     }
    //   ]
    // }
]
